import { SVGProps } from "react";

export type IconProps = { ariaHidden?: boolean } & SVGProps<SVGSVGElement>;

export function PlusIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M10.5 20a1.5 1.5 0 0 0 3 0v-6.5H20a1.5 1.5 0 0 0 0-3h-6.5V4a1.5 1.5 0 0 0-3 0v6.5H4a1.5 1.5 0 0 0 0 3h6.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EditIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="m10.756 6.17 7.07 7.071-7.173 7.174a2 2 0 0 1-1.238.578L9.239 21H4.006a1.01 1.01 0 0 1-1.004-.9l-.006-.11v-5.233a2 2 0 0 1 .467-1.284l.12-.13 7.173-7.174Zm3.14-3.14a2 2 0 0 1 2.701-.117l.127.117 4.243 4.243a2 2 0 0 1 .117 2.7l-.117.128-1.726 1.726-7.07-7.071z"
        fill="currentColor"
      />
    </svg>
  );
}

export function TrashIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M14.28 2a2 2 0 0 1 1.897 1.368L16.72 5H20a1 1 0 1 1 0 2l-.003.071-.867 12.143A3 3 0 0 1 16.138 22H7.862a3 3 0 0 1-2.992-2.786L4.003 7.07A1.01 1.01 0 0 1 4 7a1 1 0 0 1 0-2h3.28l.543-1.632A2 2 0 0 1 9.721 2zM9 10a1 1 0 0 0-.993.883L8 11v6a1 1 0 0 0 1.993.117L10 17v-6a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1m-.72-6H9.72l-.333 1h5.226z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ExpandIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M12 16c-.32 0-.63-.1-.9-.3l-4.5-3.5a1.25 1.25 0 0 1 1.5-2l3.9 3.03 3.9-3.03a1.25 1.25 0 0 1 1.5 2l-4.5 3.5c-.27.2-.58.3-.9.3"
        fill="currentColor"
      />
    </svg>
  );
}

export function CollapseIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M12 9c.32 0 .63.1.9.3l4.5 3.5a1.25 1.25 0 0 1-1.5 2L12 11.77 7.6 14.8a1.25 1.25 0 0 1-1.5-2l4.5-3.5c.27-.2.58-.3.9-.3"
        fill="currentColor"
      />
    </svg>
  );
}

export function PendingIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M12 7.5v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CartIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M5 5h14l-1.2 7.2a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="m9 11 2 2 4-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="9" cy="17.5" r="1.25" fill="currentColor" />
      <circle cx="15" cy="17.5" r="1.25" fill="currentColor" />
    </svg>
  );
}

export function QuantityIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      {...props}
    >
      <path
        d="M7 6h10M5 12h14M7 18h10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SunIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

export function MoonIcon({ ariaHidden = false, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={18}
      height={18}
      role="img"
      aria-hidden={ariaHidden}
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
    </svg>
  );
}
